import { MUTATION_KEYS, QUERY_KEYS } from "library/shared";
import { IEmployee } from "library/types";
import { useMutation, useQueryClient } from "react-query";
import api from "service/api";

import useNotificationHandler from "hooks/useNotificationHandler";

import { useInvalidateEmployeeData } from "./useGetEmployeeData";

type Params = {
  countryCode: number;
  clientInternalNumberGOS: number;
  payload: IEmployee;
};

const updateEmployee = async ({ countryCode, clientInternalNumberGOS, payload }: Params) => {
  const response = await api.patch(`/employee/${countryCode}/${clientInternalNumberGOS}`, payload);

  return response.data as IEmployee;
};

export function useUpdateEmployee(refetch = true) {
  const { handleAddAxiosErrorNotification } = useNotificationHandler();
  const queryClient = useQueryClient();
  const invalidateEmployeeDetails = useInvalidateEmployeeData();

  return useMutation(updateEmployee, {
    mutationKey: MUTATION_KEYS.updateEmployee,
    onSuccess: (data) => {
      if (refetch) {
        invalidateEmployeeDetails();
      } else {
        queryClient.setQueriesData(
          [
            QUERY_KEYS.employeeData,
            data?.countryCode?.toString(),
            data?.clientInternalNumberGos?.toString(),
          ],
          data
        );
      }
    },
    onError: (error) => {
      // handle error
      handleAddAxiosErrorNotification(error);
    },
  });
}
